import React, { useEffect }  from 'react'
import { Box } from '@mui/material'
import OrderModification from './OrderModification'
import { useDispatch } from "react-redux";
import {
  reset
} from "../centralAdminSlice";

export default function RecordModification() {
  const dispatch = useDispatch();
  useEffect(()=>{
    dispatch(reset("OnRefresh"));
  }, []);
  
  return (
    <Box>
		  <OrderModification/>
    </Box>
  )
}
